import { CalendarToday } from '@material-ui/icons';
import moment from 'moment';
import { Link } from 'react-router-dom';
import PayoutRequestIcon from '../../../icons/PayoutRequestIcon';
import UserDetails from './UserDetails';

export default function DetailsHeader({
  booking,
  hideWatchRecordingButton = false,
}) {
  return (
    <div className='bg-white rounded px-6 py-4 my-6'>
      <span className='float-right text-xs opacity-60'>
        Booking ID: {booking.id}
      </span>

      {!hideWatchRecordingButton && (
        <div>
          <Link
            to={{
              pathname: `/manage-bookings/watch-recording/${booking.id}`,
              state: { booking },
            }}
            className='bg-green-c1 text-white px-4 py-2 rounded focus:outline-none -ml-3'
          >
            WATCH RECORDINGS
          </Link>
          <hr className='border-t border-solid border-gray-300 my-4 -mx-6' />
        </div>
      )}

      <h2 className='text-xl font-medium opacity-80'>{booking.themeName}</h2>
      <h3 className='font-medium opacity-60 mt-1'>{booking.subTopicName}</h3>

      <p className='m-1 mt-4 text-xs font-medium opacity-40'>Coach</p>
      <UserDetails user={booking.Coach || {}} />

      <p className='m-1 mt-4 text-xs font-medium opacity-40'>Student</p>
      <UserDetails user={booking.Student || {}} />

      <div className='grid grid-cols-3 gap-y-2 mt-8 opacity-60'>
        <div className='flex items-center gap-2'>
          <CalendarToday />
          <span>Session scheduled on</span>
        </div>
        <div className='flex items-center gap-2'>
          <CalendarToday />
          <span>Session conducted on</span>
        </div>
        <div className='flex items-center gap-2'>
          <PayoutRequestIcon iconStyle='h-5' />
          <span>Earnings</span>
        </div>

        <span className='mx-1'>
          {moment(booking.startTime).format('DD MMM YYYY, hh:mm A')}
        </span>
        <span className='mx-1'>
          {moment(booking.conductedAt).format('DD MMM YYYY, hh:mm A')}
        </span>
        <span className='mx-1'>₹ {booking.totalEarning}</span>
      </div>
    </div>
  );
}
